<!DOCTYPE HTML>
<template>
<div class="close-button">
  <div class="x"
       @click="close()">&times;</div>

</div>
</template>

<script>
export default {
  name: 'CloseButton',
  methods: {
    close() {
      this.$emit( 'close' )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/global.scss";
.close-button {
    .x {
        width: 2rem;
        height: 2rem;
        border-radius: 100%;
        color: theme-color-level('primary', -2);
        display: grid;
        font-family: 'Roboto';
        font-size: 2.2rem;
        font-weight: 200;
        align-content: center;
        justify-content: center;
        cursor: pointer;
        background: white;
        box-shadow: 0 0 2rem theme-color-level('primary',-10);

        &:hover {
            color: theme-color-level('primary', 0);
            box-shadow: 0 0 1rem theme-color-level('primary',-7);
        }
    }
}
</style>
